<form class="account">
  <div class="header">
    <p class="title {{ coinCode }}">
      {{ isFiat ? 'Cuenta en ' + TYPE_ACCOUNT[this.coinCode] : TYPE_ACCOUNT[this.coinCode] }}
    </p>
    <div class="bank">
      <p *ngIf="account?.bankName" class="name">
        {{ account.bankName }}
      </p>
    </div>
  </div>
  <div [formGroup]="fiatAccountFormGroup" *ngIf="isFiat" class="content">
    <mat-form-field class="data-item" [hideRequiredMarker]="true" floatLabel="always">
      <mat-label class="active">Nombre</mat-label>
      <input
        matInput
        class="value"
        name="description"
        [placeholder]="account?.description || 'Cuenta sin nombre'"
        autocomplete="off"
        formControlName="description"
        [readonly]="true"
      />
      <mat-error
        *ngIf="
          (!fiatAccountFormGroup.controls.description.pristine ||
            fiatAccountFormGroup.controls.description.touched) &&
          fiatAccountFormGroup.controls.description.invalid
        "
        class="form-error"
      >
        {{ getErrorMessage('description') }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="data-item" [hideRequiredMarker]="true" floatLabel="always">
      <mat-label>CBU/CVU/Alias</mat-label>
      <input
        matInput
        class="value"
        name="cbu"
        autocomplete="off"
        formControlName="cbu"
        [readonly]="true"
      />
      <mat-error
        *ngIf="
          (!fiatAccountFormGroup.controls.cbu.pristine ||
            fiatAccountFormGroup.controls.cbu.touched) &&
          fiatAccountFormGroup.controls.cbu.invalid
        "
        class="form-error"
      >
        {{ getErrorMessage('cbu') }}
      </mat-error>
    </mat-form-field>
  </div>
  <div [formGroup]="cryptoAccountFormGroup" *ngIf="!isFiat" class="content">
    <mat-form-field class="data-item" [hideRequiredMarker]="true" floatLabel="always">
      <mat-label class="active">Nombre</mat-label>
      <input
        matInput
        name="description"
        formControlName="description"
        class="value"
        [readonly]="true"
        [placeholder]="cryptoAccountFormGroup.controls?.description.value || 'Cuenta sin nombre'"
        autocomplete="off"
      />
      <mat-error
        *ngIf="
          (!cryptoAccountFormGroup.controls.description.pristine ||
            cryptoAccountFormGroup.controls.description.touched) &&
          cryptoAccountFormGroup.controls.description.invalid
        "
        class="form-error"
      >
        {{ getErrorMessage('description') }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="data-item" [hideRequiredMarker]="true" floatLabel="always">
      <mat-label>Address</mat-label>
      <textarea
        matInput
        cols="20"
        autocomplete="off"
        style="resize: none; overflow: hidden"
        rows="2"
        class="value"
        [readonly]="true"
        formControlName="address"
        >{{ account?.address }}</textarea
      >
      <mat-error
        *ngIf="
          (!cryptoAccountFormGroup.controls.address.pristine ||
            cryptoAccountFormGroup.controls.address.touched) &&
          cryptoAccountFormGroup.controls.address.invalid
        "
        class="form-error"
      >
        {{ getErrorMessage('address') }}
      </mat-error>
    </mat-form-field>
  </div>
  <div class="img-container">
    <!-- <img *ngIf="isFiat" src="assets/icons/balance-{{ coinCode.toLowerCase() }}.svg" /> -->
    <img *ngIf="isFiat" [src]="bankIcon" #bankIconImg (error)="bankIconErrorHandler(bankIconImg)" />
    <img
      *ngIf="!isFiat"
      [src]="'assets/icons/news/' + imageCryptoCard[coinCode.toLowerCase()] + '.svg'"
    />
  </div>
  <div class="icon-options" #optionModalButton>
    <img (click)="openOptionModal()" class="icon-option" src="assets/icons/news/options.svg" />
  </div>
  <div *ngIf="optionModal" class="option-modal">
    <button (click)="handlerDelete()">
      <img src="assets/icons/del.svg" />
      Eliminar
    </button>
  </div>
  <div (click)="copyAccountInfo(account)" class="icon-copy">
    <img *ngIf="!successCopyIcon" src="assets/icons/news/copy-white.svg" />
    <img *ngIf="successCopyIcon" src="assets/icons/checked-onboarding.svg" />
  </div>
</form>
